import { AuthState } from './auth';

export default {
	loader(state: AuthState): boolean {
		return state.loader;
	},
	error(state: AuthState): any {
		return state.error;
	},
};